import store from './store';
import { resetProjectsState } from './projectsSlice';
import { resetRequestsState } from './requestsSlice';
import { resetBrdToFrdState } from './brdToFrdSlice';

/** Clear per-user Redux data when the auth session ends or a new user logs in */
export function resetSessionReduxState() {
  const dispatch = store.dispatch;
  dispatch(resetProjectsState());
  dispatch(resetRequestsState());
  dispatch(resetBrdToFrdState());
}
